<script lang="ts" setup>
import type { Maybe } from "@graphql-tools/utils";
import type { CategoryEntity } from "~~/types/graphql";
import ArrowRight from "@/assets/icons/arrow.svg?component";

const props = defineProps<{
  headline: string;
  categories?: CategoryEntity[];
  externalLink?: Maybe<string>;
}>();

const link = computed(() => {
  if (props.externalLink) {
    if (props.externalLink.includes("http")) {
      return props.externalLink;
    } else {
      return `//${props.externalLink}`;
    }
  }
  return undefined;
});

useHeaderColor("black");
</script>

<template>
  <header
    class="header-reference-detail relative flex h-4/6 flex-col bg-integer-black"
  >
    <div class="outer-space container relative z-10">
      <div
        class="grid h-full w-full content-end py-15 pt-50 text-integer-white"
      >
        <div class="flex max-w-2/3 flex-wrap gap-1">
          <BaseTag
            v-for="(category, index) in categories"
            :key="`${category.__typename}-${index}`"
            type="secondary"
            class="w-fit bg-light-black text-integer-white"
          >
            {{ category.attributes?.display_name }}
          </BaseTag>
        </div>
        <div
          :class="{ 'mt-3': categories?.length !== 0 }"
          class="flex flex-col md:flex-row"
        >
          <h1 class="hyphens-auto text-h2">
            {{ headline }}
          </h1>
          <nuxt-link
            v-if="externalLink"
            class="ml-auto mt-10 flex items-center self-end whitespace-pre hover:cursor-pointer md:mt-0 md:p-2"
            target="_blank"
            :to="link"
          >
            Zur Website <ArrowRight class="-rotate-45" />
          </nuxt-link>
        </div>
      </div>
    </div>
  </header>
</template>
